import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Row, Col, Card, CardBody, CardHeader,
  Container, Progress, Table, Button,
} from "reactstrap";
import {bindActionCreators} from "redux";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";

import FileUpload from "../../../../Form/FileUpload/components/FileUploadDefault";
import Alert from '../../../../../shared/components/Alert';
import {
  onComponentImport, stopFetchingImportComponentStatus, deleteComponentImportStatus
} from '../../../../../redux/actions/componentActions';

export class ImportComponents extends Component {

  fileUploadSubmitHandler = event => {
    if(event.files) {
      const file =
        event && event.files && event.files.length > 0
          ? event.files[0] : [];
      file && Object.keys(file).length > 0 && this.props.onComponentImport({file});
    }
  };

  fileUploadResetHandler = () => {
    this.props.deleteComponentImportStatus();
  };

  render() {
    const allowFileType = ["application/vnd.ms-excel", "text/plain", "text/csv", "text/tsv"];
    const { componentImportStatus } = this.props;

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">Import Component</h3>
            <Card className="import-file">
              <CardHeader>
                Import Asset Component
              </CardHeader>
              <CardBody>
                <Row>
                  <FileUpload
                    headerTitle="Upload Asset Component Data File"
                    allowFileType={allowFileType}
                    onSubmit={this.fileUploadSubmitHandler}
                    onCancel={this.fileUploadResetHandler}
                  />

                  <Col md={6}>
                    <Card>
                      <CardHeader>
                        Import Progress
                      </CardHeader>
                      <CardBody>
                        <Row>
                          <Col md={12}>
                            <div className="progress-wrap progress-wrap--big">
                              <Progress value={
                                componentImportStatus && componentImportStatus.progress
                                  ? componentImportStatus.progress
                                  : 0
                              }>
                                {
                                  componentImportStatus && componentImportStatus.progress
                                    ? componentImportStatus.progress
                                    : 0
                                }%
                              </Progress>
                            </div>
                            <p>
                              Current Status: { componentImportStatus && componentImportStatus.status }
                            </p>

                            {
                              componentImportStatus && componentImportStatus.status &&
                              componentImportStatus.status !== "FAILED" &&
                              <Alert color="success" hideButton="hide">
                                <p>{ componentImportStatus.message }</p>
                              </Alert>
                            }

                            {
                              componentImportStatus && componentImportStatus.status &&
                              componentImportStatus.status === "FAILED" &&
                              <Alert color="danger" hideButton="hide">
                                <p>{ componentImportStatus.message }</p>
                              </Alert>
                            }

                            <p>Validation Report</p>

                            <div className="table-wrapper">
                              <div className="table-container">
                                <table>
                                  <thead>
                                  <tr>
                                    <th>
                                      Element Type
                                      <div> Element Type </div>
                                    </th>
                                    <th>
                                      Status
                                      <div> Status </div>
                                    </th>
                                  </tr>
                                  </thead>
                                  <tbody>

                                  {
                                    componentImportStatus && componentImportStatus.error &&
                                    componentImportStatus.error.length > 0 &&
                                    componentImportStatus.error.map( (error, index) =>
                                      error.value && error.value.length > 0 ? (
                                        <tr key={index}>
                                          <td>{ error.key }</td>
                                          <td>
                                            <div>
                                              {
                                                error.value.map(
                                                  (val, valIndex) =>
                                                    <React.Fragment key={valIndex}>
                                                      { val }
                                                      { error.value.length-1 > valIndex && <React.Fragment>, </React.Fragment> }
                                                    </React.Fragment>
                                                )
                                              }
                                            </div>
                                          </td>
                                        </tr>
                                      ) : (
                                        <React.Fragment key={index} />
                                      )
                                    )
                                  }

                                  </tbody>
                                </table>
                              </div>
                            </div>

                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>

                <div className="import-footer">
                  <Button
                    color="primary"
                    type="button"
                    onClick={ () => {
                      this.props.deleteComponentImportStatus();
                      this.props.stopFetchingImportComponentStatus();
                      this.props.history.push('/settings/asset_management')
                    }}
                  >
                    Done
                  </Button>
                </div>
              </CardBody>
            </Card>

          </Col>
        </Row>
      </Container>
    );
  }
}

ImportComponents.propsType = {
  onComponentImport: PropTypes.func
};

const mapStateToProps = state => ({
  componentImportStatus: state.component.componentImportStatus,
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      onComponentImport,
      stopFetchingImportComponentStatus,
      deleteComponentImportStatus,
    },
    dispatch
  );
};

export default withTranslation('common') (
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ImportComponents)
);
